/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

//Infinite scroll functionality
class InfiniteScroll extends HTMLElement{
  constructor(){
    super()

    this.productGrid = this.closest('.collection').querySelector('#CollectionLoop')
    this.loadedNext = false

    this.checkPagination()
  }

  checkPagination(){
    const intersectionObserver = new IntersectionObserver((entries)=>{
      if(entries[0].intersectionRatio > 0){
        const baseUrl = this.dataset.baseUrl
        if(parseInt(this.dataset.currentPage) < parseInt(this.dataset.totalPages)){
          fetch(`${baseUrl}?page=${parseInt(this.dataset.currentPage)+1}&view=ajax`)
          .then(res=>res.text())
          .then(res=>{
            this.loadedNext = true
            const html = document.createElement("div")
            html.innerHTML = res
            const gridItems = html.querySelector('#CollectionLoop').innerHTML
            console.log(html)
            this.productGrid.innerHTML += gridItems
            this.setAttribute("data-current-page", parseInt(this.dataset.currentPage) + 1)
            this.loadedNext = false
            console.log("NEXT PAGE IS: ", this)
          })
        }else{
          this.classList.add("hidden")
          intersectionObserver.disconnect()
        }
      }
    })

    intersectionObserver.observe(this)
  }
}

customElements.define("infinite-scroll", InfiniteScroll)


  customElements.define("product-image-slider", class ProductImageSlider extends HTMLElement{
      constructor(){
          super()

          this.arrowPrev = this.querySelector('.js-prev-slide')
          this.arrowNext = this.querySelector('.js-next-slide')
          this.slides = this.querySelectorAll(".ProductItem__Image")
          this.currentSlide = 0
          this.moved = false
          this.maxSlides = this.slides.length - 1

          this.arrowPrev && this.arrowPrev.addEventListener("click", this.prevSlide.bind(this))
          this.arrowNext && this.arrowNext.addEventListener("click", this.nextSlide.bind(this))

          this.addEventListener("mouseenter", this.setHoveredImage.bind(this))
          this.addEventListener("mouseleave", this.removeHoveredImage.bind(this))
      }

      setHoveredImage(){
        if(this.currentSlide != 0){return}
        this.moved = false
        this.currentSlide = 1
        this.slides.forEach(slide=>slide.classList.remove("ProductItem__Image--shown"))
        this.slides[this.currentSlide].classList.add("ProductItem__Image--shown")
      }

      removeHoveredImage(){
        if(!this.moved){
          this.currentSlide = 0
          this.slides.forEach(slide=>slide.classList.remove("ProductItem__Image--shown"))
          this.slides[this.currentSlide].classList.add("ProductItem__Image--shown")
        }
      }

      prevSlide(e){
          e.preventDefault()
          this.currentSlide = this.currentSlide == 0 ? this.maxSlides : this.currentSlide-1
          this.slides.forEach(slide=>slide.classList.remove("ProductItem__Image--shown"))
          this.slides[this.currentSlide].classList.add("ProductItem__Image--shown")
          this.moved = true
      }
      
      nextSlide(e){
          e.preventDefault()
          this.currentSlide = this.currentSlide == this.maxSlides ? 0 : this.currentSlide+1
          this.slides.forEach(slide=>slide.classList.remove("ProductItem__Image--shown"))
          this.slides[this.currentSlide].classList.add("ProductItem__Image--shown")
          this.moved = true
      }
  })


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
